import VueInstance from '@/main';
import Vue from 'vue';

const utils = {
  $isEmpty(value) {
    return value === '' || (!value && value !== 0);
  },
  $isNotEmpty(value) {
    return !this.$isEmpty(value);
  },
  $pleaseDoSomething(prefix, object, toLowerCase = true) {
    let objectFirstLetter;
    objectFirstLetter = object.substr(0, 1);
    if (!!toLowerCase) {
      objectFirstLetter = objectFirstLetter.toLowerCase();
    }
    object = objectFirstLetter + object.substr(1, object.length);
    return prefix + object;
  },
  $pleaseFillIn(object, toLowerCase = true) {
    return this.$pleaseDoSomething(
      VueInstance.$t('common.please_fill_in'),
      object,
      toLowerCase
    );
  },
  $pleaseSelect(object, toLowerCase = true) {
    return this.$pleaseDoSomething(
      VueInstance.$t('common.please_select'),
      object,
      toLowerCase
    );
  },
  $checkSpeakerColor(data) {
    const category = data.category;
    const title = data.title || '';
    const isChairman = title.toLowerCase() === 'chairman';
    const materialUpdated = Number(data.materialUpdated); // 是否上传演讲材料，0没上传1已上传
    const tov = Number(data.tov);
    // 没上传演讲材料的校验内容
    const confirmationList = [
      {
        name: 'logisticsConfirmed',
        afterMeetingStatus: 'logisticsAfterMeeting'
      },
      {
        name: 'scientificConfirmed',
        afterMeetingStatus: 'scientificAfterMeeting'
      },
      {
        name: 'medicalConfirmed',
        afterMeetingStatus: 'medicalAfterMeeting'
      },
      {
        name: 'briefingConfirmed',
        afterMeetingStatus: 'briefingAfterMeeting'
      }
    ];

    // 没有上传演讲材料的校验内容
    const confirmationListForNoPresentationMaterial = [
      {
        name: 'logisticsConfirmed',
        afterMeetingStatus: 'logisticsAfterMeeting'
      },
      {
        name: 'scientificConfirmed',
        afterMeetingStatus: 'scientificAfterMeeting'
      },
      {
        name: 'medicalConfirmed',
        afterMeetingStatus: 'medicalAfterMeeting'
      }
    ];
    const getConfirmationColor = (confirmationList) => {
      let result = true;
      confirmationList.forEach((item) => {
        // 是数字非异常是1才能通过
        if (Vue.prototype.$checkConfirmationColor(data, item.name)) {
          result = false;
        }
      });
      return result ? 'green' : 'red';
    };
    let result;

    if (category === 'paid') {
      if (tov > 0) {
        // 付费讲者
        result = getConfirmationColor(confirmationList);
      } else if (tov === 0) {
        // 0元讲者
        if (Vue.prototype.$isEmpty(materialUpdated) || materialUpdated === 0) {
          result = getConfirmationColor(
            confirmationListForNoPresentationMaterial
          );
        } else if (materialUpdated === 1) {
          result = getConfirmationColor(confirmationList);
        }
      }
    } else if (category === 'unpaid') {
      // 非付费讲者
      if (isNaN(materialUpdated) || materialUpdated === 0) {
        result = getConfirmationColor(
          confirmationListForNoPresentationMaterial
        );
      } else if (materialUpdated === 1) {
        result = getConfirmationColor(confirmationList);
      }
    }

    return result;
  },
  $checkConfirmationColor(speakerData, confirmationName) {
    //   true是标红
    const confirmationList = [
      {
        name: 'logisticsConfirmed',
        afterMeetingStatus: 'logisticsAfterMeeting'
      },
      {
        name: 'scientificConfirmed',
        afterMeetingStatus: 'scientificAfterMeeting'
      },
      {
        name: 'medicalConfirmed',
        afterMeetingStatus: 'medicalAfterMeeting'
      },
      {
        name: 'briefingConfirmed',
        afterMeetingStatus: 'briefingAfterMeeting'
      }
    ];
    const confirmationStatus = Number(speakerData[confirmationName]);
    const category = speakerData.category;
    const chairmanTag = speakerData.chairmanTag; // 是否是主席
    const materialUpdated = Number(speakerData.materialUpdated); // 是否上传演讲材料，0没上传1已上传
    const afterMeetingStatusItem = confirmationList.find(
      (item) => item.name === confirmationName
    );
    const afterMeetingStatus = Vue.prototype.$isNotEmpty(afterMeetingStatusItem)
      ? afterMeetingStatusItem.afterMeetingStatus
      : null;
    const isAfterMeeting = Vue.prototype.$isNotEmpty(afterMeetingStatus)
      ? Number(speakerData[afterMeetingStatus]) === 1
      : false;
    const checker = (confirmationStatus) => {
      return (
        confirmationStatus === 0 ||
        this.$isEmpty(confirmationStatus) ||
        isAfterMeeting
      );
    };
    if (confirmationName === 'briefingConfirmed') {
      //   debugger
      if (category == 'unpaid') {
        if (chairmanTag == '1') {
          if (materialUpdated === 1) {
            return checker(confirmationStatus);
          } else { // 会前未上传演讲材料，
            return false;
          }
        } else {
          return checker(confirmationStatus);
        }
      } else if (speakerData.tov === 0) {
        if (materialUpdated === 1) {
          return checker(confirmationStatus);
        } else {
          return false;
        }
      } else if (speakerData.tov > 0) {
        return checker(confirmationStatus);
      }
    } else {
      //   debugger
      return checker(confirmationStatus);
    }
  },
  $checkTrainingConfirmationYesOrNoWithTranslation(
    speakerData,
    confirmationName
  ) {
    const result = Vue.prototype.$checkTrainingConfirmationYesOrNo(
      speakerData,
      confirmationName
    );
    return VueInstance.$t(`common.${result}`);
  },
  $checkTrainingConfirmationYesOrNo(speakerData, confirmationName) {
    const confirmationStatus = Number(speakerData[confirmationName]);
    const materialUpdated = Number(speakerData.materialUpdated);

    const category = speakerData.category;
    const chairmanTag = speakerData.chairmanTag; // 是否是主席
    const checker = (confirmationStatus) => {
      if (confirmationStatus === 1) {
        return 'yes';
      } else if (
        confirmationStatus === 0 ||
        this.$isEmpty(confirmationStatus)
      ) {
        return 'no';
      }
    };


    if (confirmationName === 'briefingConfirmed') {
      console.log('speakerData', speakerData);
      //   debugger
      if (category == 'unpaid') {
        if (chairmanTag == '1') {
          if (materialUpdated === 1) {
            return checker(confirmationStatus);
          } else { // 会前未上传演讲材料，
            return 'not_required';
          }
        } else {
          return checker(confirmationStatus);
        }
      } else if (speakerData.tov === 0) {
        if (materialUpdated === 1) {
          return checker(confirmationStatus);
        } else {
          return 'not_required';
        }
      } else if (speakerData.tov > 0) {
        return checker(confirmationStatus);
      } else {
        return checker(confirmationStatus);
      }
    } else {
      //   debugger
      return checker(confirmationStatus);
    }
  },
  $accurateCalulateOperation(a, b, op) {
    const isInteger = (obj) => {
      return Math.floor(obj) === obj;
    };
    const toInteger = (floatNum) => {
      let ret = { times: 1, num: 0 };
      if (isInteger(floatNum)) {
        ret.num = floatNum;
        return ret;
      }
      let strfi = floatNum + '';
      let dotPos = strfi.indexOf('.');
      let len = strfi.substr(dotPos + 1).length;
      let times = Math.pow(10, len);
      let intNum = parseInt(floatNum * times + 0.5, 10);
      ret.times = times;
      ret.num = intNum;
      return ret;
    };
    let o1 = toInteger(a);
    let o2 = toInteger(b);
    let n1 = o1.num;
    let n2 = o2.num;
    let t1 = o1.times;
    let t2 = o2.times;
    let max = t1 > t2 ? t1 : t2;
    let result = null;
    switch (op) {
      case 'add':
        if (t1 === t2) {
          // 两个小数位数相同
          result = n1 + n2;
        } else if (t1 > t2) {
          // o1 小数位 大于 o2
          result = n1 + n2 * (t1 / t2);
        } else {
          // o1 小数位 小于 o2
          result = n1 * (t2 / t1) + n2;
        }
        return result / max;
      case 'subtract':
        if (t1 === t2) {
          result = n1 - n2;
        } else if (t1 > t2) {
          result = n1 - n2 * (t1 / t2);
        } else {
          result = n1 * (t2 / t1) - n2;
        }
        return result / max;
      case 'multiply':
        result = (n1 * n2) / (t1 * t2);
        return result;
      case 'divide':
        result = (n1 / n2) * (t2 / t1);
        return result;
    }
  },
  $accAdd(arg1, arg2) {
    return this.$accurateCalulateOperation(arg1, arg2, 'add');
  },
  $formatEEIB: (ifEeib, isNeedCoi, restrictAttendance) => {
    if (restrictAttendance === '1') {
      return vm.$t('engagementRequest.label.block');
    } else if (isNeedCoi === '0') {
      return vm.$t('engagementRequest.label.not_required');
    } else {
      if (ifEeib === '1') {
        return vm.$t('engagementRequest.label.yes');
      } else if (ifEeib === '0') {
        return vm.$t('engagementRequest.label.no');
      } else {
        return '-';
      }
    }
  },

  $formatSeriesNumber(num) {
    num = Number(num);
    num = !isNaN(num) ? num : '';
    const aaa = toString(num);
    if (num !== '' && toString(num).length < 2) {
      num = '0' + num;
    }
    return num;
  },

  //
  // 自定义函数名：PrefixZero,数字位数不够，进行前补零的JS最简实现方案
  // @param num： 被操作数
  // @param n： 固定的总位数
  $prefixZero(num, n = 2) {
    const maxNum = Math.pow(10, n);
    if (num >= maxNum) {
      return num;
    } else {
      return (Array(n).join(0) + num).slice(-n);
    }
  },

  $trim(value) {
    let lastValue;
    if (typeof value === 'string') {
      lastValue = value.replace(/(^\s*)|(\s*$)/g, '');
    }
    return lastValue;
  },

  $setFormDataParams: (query) => {
    const formData = new FormData();
    Object.keys(query).forEach((item) => {
      formData.append(item, query[item]);
    });
    return formData;
  },
  $objectToQuery: (payload) => {
    let queryStr = '?',
      i = Object.keys(payload).length;
    if (!payload) {
      queryStr = '';
    }
    Object.keys(payload).forEach((key, index) => {
      if (i === index + 1) {
        queryStr += key + '=' + payload[key];
      } else {
        queryStr += key + '=' + payload[key] + '&';
      }
    });
    return queryStr;
  },
  $objectToParams: (payload) => {
    payload = !!payload && payload !== '' ? payload : {};
    let result = '';
    Object.keys(payload).forEach((item, index) => {
      result += '/' + payload[item];
    });
    return result;
  },
  $formatMoney(s, n) {
    if (Number(s) === 0) {
      return '0.00';
    }
    if (!s && Number(s) !== 0) {
      return '';
    }
    n = n > 0 && n <= 20 ? n : 2;
    s = parseFloat((s + '').replace(/[^\d\.-]/g, '')).toFixed(n) + '';
    let l = s.split('.')[0].split('').reverse(),
      r = s.split('.')[1];
    let t = '';
    for (let index = 0; index < l.length; index++) {
      t +=
        l[index] + ((index + 1) % 3 === 0 && index + 1 !== l.length ? ',' : '');
    }
    let result = t.split('').reverse().join('') + '.' + r;
    result = !result ? '' : result;
    return result.replace('.00','');
  },
  $toThousand(val, n, fd=2) {
    if (!val) {
      return 0;
    }

    if(!n) {
      n = 1;
    }

    return Number((val/(1000*n)).toFixed(fd));
  },
  $toTenThousand(val, n) {
    if (!val) {
      return 0;
    }

    if(!n) {
      n = 1;
    }

    return Number((val/(10000*n)).toFixed(2));
  },
  $all(iterators) {
    const promises = Array.from(iterators); // 强制转换成数组
    const len = promises.length; // 记录数组的长度
    let count = 0; // 标记成功的个数
    let resultList = [];// 要返回的 数组结果
    return new Promise((resolve, reject) => {  // 返回一个promise
      for (let index in promises) { // for 循环配合 let 确保 数组结果和参数顺序一致
        Promise.resolve(promises[index])         // Promise.resolve，如果是参数是promise 直接返回，如果不是则直接执行Promise.resolve方法 到 then 接受
          .then((result) => {
            count++;          // 记录个数，等于len时 resolve
            resultList[index] = result; // 对应赋值结果
            if (count === len) {
              resolve(resultList);
            }
          })
          .catch(e => {
            reject(e); // 当收到错误时，直接reject，返回错误信息
          })
      }
    })
  },
  $getWindowTarget() {
    const ua = navigator.userAgent;
    console.log('ua:', ua);
    const isAndroid = /(?:Android)/.test(ua);
    const isFireFox = /(?:Firefox)/.test(ua);
    const isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua));
    const isAZLink = /azlink_ipad/.test(ua);
    let target = '_blank';
    if (isTablet || isAZLink) {
      target = '_self';
    }
    return target;
  }
};

utils.install = function(Vue) {
  Object.keys(utils).forEach((item, index) => {
    if (item !== 'install') {
      Vue.prototype[item] = utils[item];
    }
  });
};

export default utils;



// WEBPACK FOOTER //
// ./src/util/utils.js